import * as React from 'react';
import qs from 'qs';
import { Flex } from '@lightspeed/flame/Core';
import withLocalizeAwareIframe from 'pages/utils/withLocalizeAwareIframe';
import withRouteAwareIframe from 'pages/utils/withRouteAwareIframe';
import withValidSessionIframe from 'pages/utils/withValidSessionIframe';

const OMNILocationsIframe = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const UUID = searchParams.get('UUID') || searchParams.get('uuid');
  const locationName = searchParams.get('name');

  const nextRouteParams = qs.stringify({
    host: 'omni',
  });

  const nextSearchParams = window.location.search
    ? `${window.location.search}&${nextRouteParams}`
    : `?${nextRouteParams}`;

  // Users should never reach `/new` route because locations are created first in Retail
  const nextRoute = UUID ? `/edit/${UUID}${nextSearchParams}` : `/new${nextSearchParams}`;

  React.useEffect(() => {
    window.merchantos.asyncSubscribe.notifySubscribers('react.mount.topbar', {
      props: {
        crumbs: [
          {
            type: 'ui_tab',
            text: 'Settings',
            name: 'admin',
          },
          {
            type: 'listing',
            text: 'Locations',
            name: 'admin.listings.shops',
          },
          {
            text: locationName,
          },
        ],
      },
    });
  });

  return (
    <Flex flexDirection="column" style={{ height: '100%' }}>
      <style
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: `
            .view_tab_omni-locations  .content { padding: 0 }
            .react-page { height: calc(100%) }`,
        }}
      />
      <iframe
        title="OMNI Locations"
        src={`/webapps_redirect.php?app=omni-locations&next=${encodeURIComponent(nextRoute)}`}
        frameBorder="0"
        style={{
          border: 'none',
          display: 'block',
          overflow: 'hidden',
          height: '100%',
        }}
      />
    </Flex>
  );
};

export default withLocalizeAwareIframe(
  withRouteAwareIframe(withValidSessionIframe(OMNILocationsIframe))
);
